import React from 'react';
import { CustomButton } from '../../../../components/Button/Button';
import { Icon } from '../../../../components/Icon';
import { useTranslation } from 'react-i18next';
import styles from './EditSubtitleButtons.module.scss';
import { MISSING_MODE } from '../../const';
import MisingSubtitlesNotification from '../MisingSubtitlesNotification/MisingSubtitlesNotification';
import { useUserContext } from '../../../../context/UserContext';

const { TRANSCRIPTION, TRANSLATION } = MISSING_MODE;

const EditSubtitleButtons = ({
  onEnhance,
  onGenerateVoiceover,
  onTranslate,
  onRevert,
  onRemove,
  hasChanged,
  isMissing,
  handleDisableMissing,
  handleGenerateTranscription,
  handleTranslate,
  loading,
  isOnTranslation,
}) => {
  const { t } = useTranslation();
  const { isImproveSubtitlesEnabled, isGenerateVoiceoverEnabled } = useUserContext();

  const handleRemove = () => {
    const confirmRemove = confirm(t('subtitles.editor.confirm_remove'));
    if (confirmRemove) {
      onRemove();
    }
  };

  const showPrimaryButtons = isImproveSubtitlesEnabled || isGenerateVoiceoverEnabled;

  return !loading ? (
    <>
      <div className={styles.btnsContainer}>
        {showPrimaryButtons && (
          <div className={styles.btnsContainerRow}>
            {isImproveSubtitlesEnabled && (
              <CustomButton variant="primary" onClick={onEnhance} disabled={hasChanged || (isMissing[TRANSCRIPTION])}>
                <Icon src="scriptGeneratorWhite" className={styles.btnIcon} />
                <span>Improve Subtitles</span>
              </CustomButton>
            )}
            <CustomButton variant="primary" onClick={onTranslate} disabled={hasChanged || (isMissing[TRANSCRIPTION])}>
              <Icon src="translate" className={styles.btnIcon} />
              <span>{t('subtitles.editor.button_translate')}</span>
            </CustomButton>
            {isGenerateVoiceoverEnabled && (
              <CustomButton variant="primary" onClick={onGenerateVoiceover} disabled={hasChanged || (isMissing[TRANSCRIPTION])}>
                <Icon src="microWhite" className={styles.btnIcon} />
                <span>Generate Voiceover</span>
              </CustomButton>
            )}
          </div>
        )}
        <div className={styles.btnsContainerRow}>
          {!showPrimaryButtons && (
            <CustomButton variant="primary" onClick={onTranslate} disabled={hasChanged || (isMissing[TRANSCRIPTION])}>
              <Icon src="translate" className={styles.btnIcon} />
              <span>{t('subtitles.editor.button_translate')}</span>
            </CustomButton>
          )}
          <CustomButton variant="link" onClick={onRevert} className={styles.linkButtons}>
            <Icon src="revert" className={styles.btnIcon} />
            <span>{t('my_video.tools.trim.revert')}</span>
          </CustomButton>
          <CustomButton variant="link" onClick={handleRemove} className={styles.linkButtons}>
            <Icon src="bin" className={styles.btnIcon} />
            <span>{t('subtitles.editor.button_delete')}</span>
          </CustomButton>
        </div>
      </div>
      <MisingSubtitlesNotification
        mode={TRANSCRIPTION}
        visible={isMissing[TRANSCRIPTION]}
        onGenerate={handleGenerateTranscription}
        onDisable={handleDisableMissing}
      />
      <MisingSubtitlesNotification
        mode={TRANSLATION}
        visible={!isMissing[TRANSCRIPTION] && isMissing[TRANSLATION] && isOnTranslation}
        onGenerate={handleTranslate}
        onDisable={handleDisableMissing}
      />
    </>
  ) : null;
};

export default EditSubtitleButtons;
